import React, { useContext, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { useRefinementList } from 'react-instantsearch';

import Copy from '@components/atoms/copy/copy';
import FilterTag from '@components/atoms/filter-tag/filterTag';
import { Context } from '../../../context/provider';

const FilterContentTypes = () => {
  const t = useTranslations();
  const { filter, setContentTypesOpen } = useContext(Context);
  const { refine, items } = useRefinementList({ attribute: 'content_type' });

  const toggleContentTypes = () => {
    setContentTypesOpen(!filter.contentTypesOpen);
  };

  useEffect(() => {
    if (items.length === 0) setContentTypesOpen(false);
  }, [items]);

  return (
    <div className="content-types">
      <div className="icon-wrapper">
        <button
          type="button"
          disabled={items.length === 0}
          className="type-toggle-wrapper"
          onClick={toggleContentTypes}
          onKeyDown={toggleContentTypes}
        >
          <span className="type-toggle-icon">{filter.contentTypesOpen ? '-' : '+'}</span>
          <Copy className="type-toggle-copy" uppercase small role="button">
            {t('archive.contentTypesLabel')}
          </Copy>
        </button>
      </div>

      {filter.contentTypesOpen && (
        <div className="content-types__tags">
          {items.map((contentType, index) => (
            <FilterTag
              key={index}
              inverted={contentType.isRefined}
              onClick={() => refine(contentType.value)}
              role="button"
              border
            >
              {contentType.value}
            </FilterTag>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterContentTypes;
